import UseContext from "../../../../../../../hooks/useContext";
import useSlideOver from "../../../../../../../components/SlideOver/useSlideOver";
import useModal from "../../../../../../../components/modal/useModal";
import Badge from "../../../../../../../components/badge/badge";
import CopyToClipboard from "../../../../../../../components/copyToClipboard";
import {BanIcon, Dots, EyeIcon, Localisation, Plus} from "../../../../../../../assets/icons";
import DropdownMenu from "../../../../../../../components/DropdownMenu/DropdownMenu";
import {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import TableRow from "../../../../../../../components/table/components/TableRow";

const TbodyVivier = ({champsBody, setAddVivier, list, selectAll, selectedId, setSelectedId}) => {
    const {objID, setObjID, setInfoVivier} = UseContext()
    const {toggleSlideOver} = useSlideOver();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropDownRef = useRef()
    const {toggle} = useModal()
    const navigate = useNavigate();

    const handleCheckboxChange = () => {
        // Vérifiez si la case à cocher d'en-tête est cochée pour décider de l'état des cases à cocher individuelles
        const checked = list.includes(champsBody._id);

        // Mettez à jour l'état de la case à cocher individuelle
        if (checked) {
            setAddVivier(list.filter((item) => item !== champsBody._id));
        } else {
            setAddVivier([...list, champsBody._id]);
        }
    };

    const openTempWorkerInfo = (id) => {
        const workerId = id || champsBody?._id;
        setObjID(workerId);
        setSelectedId(workerId);
        toggleSlideOver('get_temp_worker');
        
        // Mettre à jour l'URL pour synchroniser la sélection
        const currentUrl = window.location.pathname;
        const params = new URLSearchParams(window.location.search);
        params.set('idTempWorker', workerId);
        window.history.replaceState({}, '', `${currentUrl}?${params.toString()}`);
    };

    useEffect(() => {
        let handler = (e) => {
            if (!dropDownRef.current.contains(e.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, []);

    const handleDropDown = () => {
        setDropdownOpen((prev) => !prev);
    };

    const excludeAgencySelected = () => {
        setInfoVivier({ listUsers: [champsBody._id] });
        toggle('exclude_agency');
    };

    const addVivierSelected = () => {
        setInfoVivier({ listUsers: [champsBody._id] });
        toggle('vivier_add');
    };

    const changeLocalisation = () => {
        setInfoVivier({ listUsers: [champsBody._id] });
        toggle('localisation_preferences');
    };

    return (
        <>
            {!champsBody?.isDeleted && (
                <TableRow
                    key={champsBody._id}
                    itemId={champsBody._id}
                    selectedId={selectedId}
                    onClick={openTempWorkerInfo}
                >
                    <td className="py-5 pl-4 md:pl-8 pr-2 min-w-[280px]">
                        <div className='flex items-center gap-4' onClick={(e) => {
                            e.stopPropagation();
                            handleCheckboxChange();
                        }}>
                            <input type="checkbox" checked={list?.includes(champsBody._id)} readOnly/>
                            <div>
                                <div className='text-sm text-gray-900 flex gap-1 items-center'>
                                    <div className='truncate'>
                                        {champsBody.firstname} {champsBody.lastname}
                                    </div>
                                    <div className='text-gray-500 text-xs flex-shrink-0'>
                                        <CopyToClipboard text={champsBody.id_bestt}>
                                            (N° {champsBody.id_bestt})
                                        </CopyToClipboard>
                                    </div>
                                </div>
                                <div className='flex gap-4'>
                                    {champsBody.token_refresh_mobile ? <Badge type={'APP'}>App</Badge> : ""}
                                    {champsBody.token_refresh ? <Badge type={'WEB'}>Web</Badge> : ""}
                                </div>
                            </div>
                        </div>
                    </td>
                    <td className="py-5 px-2 min-w-[200px]">
                        {champsBody.phone ?
                            <CopyToClipboard text={champsBody.phone}>
                            <span className='text-sm text-gray-700'>
                                {champsBody.phone}
                            </span>
                            </CopyToClipboard>
                            : null
                        }
                        {
                            champsBody.email ?
                                <CopyToClipboard text={champsBody.email}>
                                <span className='text-sm text-gray-500'>
                                    {champsBody.email}
                                </span>
                                </CopyToClipboard>
                                : null
                        }
                    </td>
                    <td className="py-5 px-2 min-w-[120px] max-w-[180px]">
                        <p className="truncate text-sm text-gray-500">
                            {champsBody?.viviers?.join("/ ")}
                        </p>
                    </td>
                    <td className="py-5 pl-2 pr-4 md:pr-8">
                        <div className={'flex items-center gap-2 justify-end'}>
                            <div className={'cursor-pointer w-9 h-9 flex items-center justify-center rounded hover:bg-gray-100'} onClick={(e) => {
                                e.stopPropagation();
                                openTempWorkerInfo(champsBody?._id);
                            }}>
                                <EyeIcon wh={20} color={'#374151'}/>
                            </div>
                            <div className={'relative cursor-pointer w-9 h-9 flex justify-center items-center rounded hover:bg-gray-100'} ref={dropDownRef} onClick={(e) => {
                                e.stopPropagation();
                                handleDropDown();
                            }}>
                                <Dots w={14} h={4} color={'#374151'}/>
                                {dropdownOpen && (
                                    <div className="absolute right-8 -bottom-8 z-[9999]">
                                        <DropdownMenu
                                            width="w-56"
                                            items={[
                                                {
                                                    icon: Plus,
                                                    label: 'Ajouter dans un vivier',
                                                    onClick: () => addVivierSelected()
                                                },
                                                {
                                                    icon: Localisation,
                                                    label: 'Modifier la localisation',
                                                    onClick: () => changeLocalisation()
                                                },
                                                { separator: true },
                                                {
                                                    icon: BanIcon,
                                                    label: 'Exclure de l\'agence',
                                                    onClick: () => excludeAgencySelected(),
                                                    iconColor: '#DC2626',
                                                    className: 'text-red-500'
                                                }
                                            ]}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </td>
                </TableRow>
            )}
        </>
    )
}

export default TbodyVivier;